/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_LevelInputs */



/**
* | output |
* | --- |
* | "Level" |
*
* @param {Common_LevelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_level = /** @type {((inputs?: Common_LevelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_LevelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Niveau")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nivel")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nível")
	if (locale === "it") return /** @type {LocalizedString} */ ("Livello")
	return /** @type {LocalizedString} */ ("Level")
});